import { PropsWithChildren } from 'react'
import { Heading } from './ModalColumnHeading.ui'

interface Props {}

export function ModalColumnHeading({ children }: PropsWithChildren<Props>) {
  return <Heading>{children}</Heading>
}
